var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgGuidelineModeration = function SvgImgGuidelineModeration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1CD092",
    d: "M23.278 35.632a2.72 2.72 0 0 1-2.592 0c-6.1-3.294-10.14-5.636-10.14-11.92V15.83a2.21 2.21 0 0 1 1.258-1.98l9.3-4.418a2.1 2.1 0 0 1 1.792 0l9.301 4.418a2.19 2.19 0 0 1 1.258 1.98v7.863c-.038 6.303-4.078 8.625-10.177 11.939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.252 16.87H20.77a.666.666 0 0 0-.668.667v10.119c0 .369.299.668.668.668h2.482c.369 0 .668-.3.668-.668V17.537c0-.369-.3-.668-.668-.668"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.737 23.838v-2.482a.67.67 0 0 0-.668-.669H16.951c-.37 0-.668.3-.668.669v2.481c0 .37.299.669.668.669h10.118c.37 0 .668-.3.668-.669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#76E2BD",
    fillRule: "evenodd",
    d: "M21.999 4.58c-9.621 0-17.42 7.799-17.42 17.42s7.799 17.42 17.42 17.42q.436 0 .868-.02l.164 3.336a21 21 0 0 1-1.032.025C10.533 42.761 1.237 33.466 1.237 22S10.533 1.238 22 1.238 42.76 10.534 42.76 22q0 .26-.006.518l-3.34-.082q.005-.217.005-.436c0-9.621-7.799-17.42-17.42-17.42",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#76E2BD",
    fillRule: "evenodd",
    d: "m42.33 26.035-.449 1.609a21 21 0 0 1-.531 1.636l-3.132-1.164q.25-.672.445-1.37l.45-1.61zm-2.44 6.354a21 21 0 0 1-1.951 2.824l-2.583-2.12a17.5 17.5 0 0 0 1.639-2.37zm-4.339 5.289a21 21 0 0 1-2.76 2.04l-1.758-2.84q1.232-.764 2.317-1.714zm-5.82 3.599q-.795.324-1.618.583l-1.594.501-1.001-3.187 1.593-.5q.69-.218 1.356-.49z",
    clipRule: "evenodd"
  })));
};
export default SvgImgGuidelineModeration;